export type FieldId = string

export type AppFailure = { kind: 'technical'; message: string }

export type Failure = { ok: false } & AppFailure

export type Result<T> = { ok: true; data: T } | Failure

export const ok = <T>(data: T): Result<T> => ({ ok: true, data })
export const technical = (message: string): Failure => ({ ok: false, kind: 'technical', message })
